// api/checkoutApi.ts
import client from './client';
import type {CheckoutData, UpdateProfileData, UserMinimal} from '~/types/types';

export const postCheckout = async (checkoutData: CheckoutData): Promise<void> => {
    try {
        const response = await client.post('/auth/checkout', checkoutData);
        return response.data; // Assuming the server might return something useful
    } catch (error) {
        console.error('Error during checkout:', error);
        throw error; // Rethrowing the error is good for handling it later in the component
    }
};

export const getUserByUniqueCode = async (uniqueCode: string): Promise<UserMinimal> => {
    try {
        const response = await client.get<UserMinimal>(`/auth/user-by-code/${uniqueCode}`);
        return response.data; // Returns the user data
    } catch (error) {
        console.error('Error fetching user by unique code:', error);
        throw error; // Rethrowing the error to handle it in the component
    }
};

export const confirmEmail = async (uniqueCode: string): Promise<any> => {
    try {
        const response = await client.get<any>(`/auth/confirm-email/${uniqueCode}`);
        return response.data; // Returns the user data
    } catch (error) {
        console.error('Error fetching user by unique code:', error);
        throw error; // Rethrowing the error to handle it in the component
    }
};
export const getUniqueCode = async (): Promise<UserMinimal> => {
    try {
        const response = await client.get<UserMinimal>(`/auth/generate-code`);
        return response.data; // Returns the user data
    } catch (error) {
        console.error('Error fetching user by unique code:', error);
        throw error; // Rethrowing the error to handle it in the component
    }
};
export const getCodeForUser = async (email: string): Promise<UserMinimal> => {
    try {
        const response = await client.get<UserMinimal>(`/auth/get-code?email=${email}`);
        return response.data; // Returns the user data
    } catch (error) {
        console.error('Error fetching user by unique code:', error);
        throw error; // Rethrowing the error to handle it in the component
    }
};

export const updateProfile = async (profileData: UpdateProfileData): Promise<void> => {
    try {
        const response = await client.put('/auth/update-profile', profileData);
        return response.data; // Assuming the server returns the updated profile
    } catch (error) {
        console.error('Error updating profile:', error);
        throw error; // Rethrowing the error to handle it in the component
    }
};


export const postContact = async (payload: any, token: string): Promise<void> => {
    try {
        const response = await client.post('/auth/contact', payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data; // Assuming the server might return something useful
    } catch (error) {
        console.error('Error during checkout:', error);
        throw error; // Rethrowing the error is good for handling it later in the component
    }
};